global.$ = require('jquery');
global.theme = {
    '$win': $(window),
    '$doc': $(document),
    '$body': $('body'),
};

const WebFont = require('./modules/fonts');
const a11y = require('./modules/a11y');
const polyfill = require('./modules/polyfills');
const navbar = require('./modules/prioritynavbar');
const headersearch = require('./modules/headersearch');
const notificationBar = require('./modules/notificationbar');
const testimonials = require('./modules/testimonials');
const videoSlider = require('./modules/videoslider');
const featureSlider = require('./modules/featureslider');
const dialog = require('./modules/dialog');
const pricingWidget = require('./modules/pricingwidget');
const gallery = require('./modules/gallery');
const twoColumn = require('./modules/twocolumnsection');
const logomarquee = require('./modules/logomarquee');
const woocommerce = require('./modules/woocommerce');
const carousel = require('./modules/carousel');
const accordion = require('./modules/accordion');
const tableofcontents = require('./modules/tableofcontents');
const blocks = require('./modules/blocks');
const ajax = require('./modules/ajax');
const pdfmodal = require('./modules/pdfmodal');
